import React from 'react'
import ReactCountdown from 'react-countdown'

import useConfiguration from '../../hooks/useConfiguration'
import CountdownContainer from '../../containers/Countdown'


export default function withCountDown(WrappedComponent) {
  return (props) => {
    // eslint-disable-next-line
    const { data } = props
    const { configuration, isDateElapsed } = useConfiguration(data)

    if (!isDateElapsed(configuration?.countdown) && typeof window === 'undefined') {
      return null
    }

    return (
      <ReactCountdown
        date={configuration?.countdown}
        renderer={({ completed }) => {
          if (completed) {
            return <WrappedComponent {...props} />
          }
          return <CountdownContainer {...props} />
        }}
      />
    )
  }
}
